module.exports = __webpack_public_path__ + "static/recard-logo@2x-fa29c41c9120955f3ee228862d91002f.png";